module.exports = __webpack_public_path__ + "static/room-ac2e8e170679d5833c1c6b497472e0c0.png";